import { BarChart3, User } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import SoccerPitchIcon from '../../../icon/soccer-pitch-icon';
import TeamsIcon from '../../../icon/teams-icon';
import MenuItemIcon from '../menu-item/menu-item';
import * as S from './styles';

type UDMenuCategoriesProps = {
  className?: string;
};

const UDMenuCategories = React.memo((props: UDMenuCategoriesProps) => {
  return (
    <S.MenuMainNavigation className={props.className}>
      <div className={'d-flex flex-column'}>
        <MenuItemIcon to={Pages.TEAMS.INDEX} icon={<TeamsIcon />} label={'Команды'} />

        <MenuItemIcon to={Pages.PLAYERS.INDEX} icon={<User size={16} />} label={'Игроки'} />

        <MenuItemIcon to={Pages.LOCATIONS.INDEX} icon={<SoccerPitchIcon />} label={'Локации'} />

        <MenuItemIcon to={Pages.ANALYTICS.INDEX} icon={<BarChart3 size={16} />} label={'Аналитика'} adminOnly={true} />
      </div>
    </S.MenuMainNavigation>
  );
});

export default UDMenuCategories;
